import React, { useState } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import './DataUsage.css';

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

const DataUsage = () => {
  const [isEnabled, setIsEnabled] = useState(true);

  const handleToggle = () => {
    setIsEnabled((prev) => !prev);
  };

  const data = {
    labels: ['Download', 'Upload'],
    datasets: [
      {
        data: [6, 20],
        backgroundColor: ['#7CBED0', '#ADE1BB'],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.label}: ${context.raw} GB`,
        },
      },
    },
    cutout: '70%',
  };

  return (
    <div className="card-content">
      <div className="chart-container">
        <Doughnut data={data} options={options} />
        <div className="chart-center-text">
          <p>Total used</p>
          <h2>26.03 GB</h2>
        </div>
      </div>
      <div className="legend">
        <div>
          <span
            className="legend-color"
            style={{ backgroundColor: '#8BC34A' }}
          ></span>
          <span>Download</span>
        </div>
        <div>
          <span
            className="legend-color"
            style={{ backgroundColor: '#03A9F4' }}
          ></span>
          <span>Upload</span>
        </div>
      </div>
      {/* <button className="btn-speed-test">Run speed test</button> */}
    </div>
  );
};

export default DataUsage;

